export default {"src":"/_next/static/media/img-dashboard-ready.2f9e3699.svg","height":186,"width":250,"blurWidth":0,"blurHeight":0};